import React from 'react'
import { Menu } from '@material-ui/core'

import BaseItem from './Item'
import Toggle from './Toggle'
import { links } from '../../../../../constants/links'

const Programmes = ({ hideMenu }) => {
  const [anchorElement, setAnchorElement] = React.useState(null)

  const handleClick = (event) => setAnchorElement(event.currentTarget)

  const handleClose = () => setAnchorElement(null)

  const handleItemClick = () => {
    handleClose()
    if (hideMenu) hideMenu()
  }

  const Item = (props) => <BaseItem {...props} onClick={handleItemClick} />

  const menuId = 'programmes'

  return (
    <>
      <Toggle handleClick={handleClick} menuId={menuId} />
      <Menu
        id={menuId}
        anchorEl={anchorElement}
        open={Boolean(anchorElement)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
        }}
      >
        <Item to={links.aLevelsComputing}>A' Levels Computing</Item>
        <Item to={links.oLevelsComputing}>O' Levels Computing</Item>
        <Item to={links.ibComputing}>IB Computing</Item>
        <Item to={links.igcseComputing}>IGCSE Computing</Item>
        <Item to={links.internationalSchools}>International Schools</Item>
      </Menu>
    </>
  )
}

export default Programmes
